import { memo } from 'react';

import { PlayIcon } from '@air/design-icons';

export type WorkspaceAgentPlayOverlayProps = {
  /** Named only by the hosts whose specs assert the disc is drawn. */
  testId?: string;
};

/**
 * The disc that says a still is timed media, centred on whatever positioned box draws the still. One
 * component so the mark stays the same size and weight wherever the panel letterboxes a frame — the
 * preview card and the mention picker's row preview both hang it over the same gray ground.
 *
 * Decorative throughout: the card or row it sits on already names its subject, and the disc plays
 * nothing on its own, so it is hidden from readers and never takes the pointer off the box behind it.
 */
export const WorkspaceAgentPlayOverlay = memo(({ testId }: WorkspaceAgentPlayOverlayProps) => (
  <span
    aria-hidden
    className="pointer-events-none absolute flex size-9 items-center justify-center rounded-full bg-black/60"
    data-testid={testId}
  >
    <PlayIcon className="ml-0.5 text-white" fill="currentColor" size={14} />
  </span>
));

WorkspaceAgentPlayOverlay.displayName = 'WorkspaceAgentPlayOverlay';
